/*fx.ns("filters", class LayoutFrameFilter extends fx.Filter {

	constructor()
	{
        super();

        this._collectionid = 0;
    }

      get collectionid()
    {
        return this._collectionid;
    }

    set collectionid(val)
    {
        this._collectionid = val;
        this._changed = true;
        this.trigger("updated");
    }

	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];

        let layouts = this.rawData.sort( this._sortLayouts );

        // let sort layouts by photo

        let numPhotos = []; 
        for (let i = 0; i < layouts.length; i++)
        {
            let layout = layouts.getItemAt(i);
            
            
            if (!numPhotos[layout.num_photos])
            {
                this.transformedData.push( {type : "label", text : fx.text("$ photos", layout.num_photos)});
                numPhotos[layout.num_photos] = true;
            }

            //if (layout.collection_id != this.collectionid)
            //        continue;

            this.transformedData.push( layout );
        }
    
		return this.transformedData;
	}	


    _sortLayouts(a, b)
    {
        if (a.collection_id == b.collection_id)
            return a.num_photos - b.num_photos;
        else
            return a.collection_id - b.collection_id;
    }

});*/